import AccountDetails from '../../../banking/components/spaces/AccountDetails';

const AccountDetailsScreen = () => {
    return <AccountDetails />;
};

export default AccountDetailsScreen;
